// src/pages/Dashboard/components/CasePanel/AnalysisSection/AnalysisSection.js

import React, { useMemo } from 'react';
import AnalysisItem from './AnalysisItem';
import { processarAnalise } from '../../../utils/analysisProcessor';
import './AnalysisSection.css';

/**
 * Seção de análise jurídica com itens colapsáveis
 * @param {object} caso - Caso selecionado
 * @param {function} onCopy - Callback para copiar conteúdo
 */
const AnalysisSection = ({ caso, onCopy }) => {
  const { casoUso, estrategia, fundamentacao } = useMemo(
    () => processarAnalise(caso),
    [caso]
  );

  const handleCopy = async (texto) => {
    try {
      await navigator.clipboard.writeText(texto);
      alert('Conteúdo copiado!');
    } catch (error) {
      console.error('Erro ao copiar:', error);
      alert('Erro ao copiar conteúdo');
    }
  };

  return (
    <div className="secao-analise-dashboard">
      <h3>Análise</h3>
      <AnalysisItem 
        title="Estudo de Caso" 
        content={casoUso} 
        onCopy={onCopy || handleCopy}
      />
      <AnalysisItem 
        title="Estratégias" 
        content={estrategia} 
        onCopy={onCopy || handleCopy}
      />
      <AnalysisItem 
        title="Fundamentação Legal" 
        content={fundamentacao} 
        onCopy={onCopy || handleCopy}
      />
    </div>
  );
};

export default AnalysisSection;